import { defineProp } from '@nzyme/vue-utils/defineProp.js';
import { defineComponent, h } from 'vue';
import { RouterLink } from 'vue-router';
export const MarkdownRenderer = defineComponent({
    name: 'MarkdownRenderer',
    props: {
        markdown: defineProp(),
        customNodes: defineProp(),
    },
    setup(props) {
        return () => {
            const content = props.markdown;
            if (!content) {
                return null;
            }
            return renderNode(content, props);
        };
    },
});
function renderNode(node, props) {
    const customNode = props.customNodes?.[node.type];
    if (customNode) {
        return h(customNode, { node });
    }
    switch (node.type) {
        case 'break':
            return h('br');
        case 'code':
            return h('code', null, node.value);
        case 'emphasis':
            return h('em', null, renderChildren(node, props));
        case 'heading':
            return h(`h${node.depth}`, null, renderChildren(node, props));
        case 'link':
            if (node.url.startsWith('http')) {
                return h('a', { href: node.url, target: '_blank' }, node.children.length ? renderChildren(node, props) : node.url);
            }
            return h(RouterLink, { to: node.url }, node.children.length ? renderChildren(node, props) : node.url);
        case 'list':
            return h(node.ordered ? 'ol' : 'ul', null, renderChildren(node, props));
        case 'listItem':
            return h('li', null, renderChildren(node, props));
        case 'paragraph':
            return h('p', null, renderChildren(node, props));
        case 'root':
            return node.children.map(child => renderNode(child, props));
        case 'strong':
            return h('b', null, renderChildren(node, props));
        case 'text':
            return node.value;
        // Every other mdast node — tables, images, blockquotes, inline code, footnotes, raw HTML —
        // renders nothing. That is the behaviour this renderer has always had; making it explicit
        // rather than falling off the end of the function so a reader can see what is unsupported.
        // Pass a `customNodes` entry to render one of them.
        default:
            return undefined;
    }
}
function renderChildren(node, props) {
    return {
        default: () => node.children.map(child => renderNode(child, props)),
    };
}
//# sourceMappingURL=MarkdownRenderer.js.map